import { render, staticRenderFns } from "./profitRoll.vue?vue&type=template&id=7051ba9c"
import script from "./profitRoll.js?vue&type=script&lang=js&external"
export * from "./profitRoll.js?vue&type=script&lang=js&external"
import style0 from "./profitRoll.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports